import { render, staticRenderFns } from "./StudentSubjects.vue?vue&type=template&id=183080e2&scoped=true&"
import script from "./StudentSubjects.vue?vue&type=script&lang=js&"
export * from "./StudentSubjects.vue?vue&type=script&lang=js&"
import style0 from "./StudentSubjects.vue?vue&type=style&index=0&id=183080e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183080e2",
  null
  
)

export default component.exports